import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

export const sentryInit = (dsn: string) => {
  Sentry.init({
    dsn,
    integrations: [ new Integrations.BrowserTracing() ],
    environment: process.env.NX_PUBLIC_ENVIRONMENT || 'local',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
};
